// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { View } from 'app/scripts/views/internal/View';
const t = teacupWithHelpers('request_admin_invite');

// eslint-disable-next-line @trello/no-module-logic, @typescript-eslint/no-explicit-any
const template = t.renderable(({ memberInviter }: any) =>
  t.div('.invitation-link-description.request-admin-invite', function () {
    t.h2(() => t.format('lets-add-you-to-this-board-in-another-way'));
    return t.p('.invitation-link-explanation', () =>
      t.format('has-shared-this-board-with-you', {
        memberInviterName: memberInviter.fullName,
      }),
    );
  }),
);

interface RequestAdminInviteView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  memberInviter: any;
}

class RequestAdminInviteView extends View {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'invitation-link';
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ memberInviter }: any) {
    this.memberInviter = memberInviter;
  }
  render() {
    this.$el.html(template({ memberInviter: this.memberInviter }));
    return this;
  }
}

RequestAdminInviteView.initClass();
export { RequestAdminInviteView };
